import { BuildingDTO } from "./building";
import { FileLog } from "./file";
import { HelpdeskTicketInterface } from "./helpdesk";
import { Resource } from "./resource";
import { UnitDTO } from "./unit";
import { ClerkUser } from "./user";


export enum InsuranceIssueStatus {
    GATHERING_INFO = "Info verzamelen",
    OPEN_INSURANCE_COMPANY = "Dossier geopend bij verzekeringsmaatschappij",
    RESOLVED = "Opgelost",
    PAYMENT_RECEIVED = "Betaling ontvangen",
}

export enum VisitationRequiredWithInsuranceExpert {
    YES = "Ja",
    NO = "Nee",
    UNKNOWN = "Onbekend",
}

export enum InsuranceIssueRole {
    UNKNOWN = "Onbekend",
    BENEFICIARY = "Begunstigde partij",
    LIABLE_PARTY = "Aansprakelijke partij",
}

export interface InsuranceIssue {
    id?: number;
    title: string;
    building?: BuildingDTO;
    buildingId?: string | null;
    unit?: UnitDTO;
    unitId?: string | null;
    actionsTaken: string | null;
    rentalContractId?: number | null;
    complexities: string;
    insuranceIssueStatus: InsuranceIssueStatus;
    visitationRequiredWithInsuranceExpert: VisitationRequiredWithInsuranceExpert;
    role: InsuranceIssueRole;
    description: string | null;
    helpdeskTickets?: HelpdeskTicketInterface[];
    resolvedInfo: string | null;
    insuranceCompanyYallyResourceId: number | null;
    insuranceCompanyYally?: Resource;
    insuranceCompanyCounterpartyResourceId: number | null;
    insuranceCompanyCounterparty?: Resource;
    counterpartyResourceId: number | null;
    counterparty?: Resource;
    fileLogIds?: number[];
    fileLogs?: FileLog[];
    askedCompensation: string | null;
    receivedCompensation: string | null;
    insuranceIssueDocuments?: number[] | null;
    createdAt?: Date;
    updatedAt?: Date;
    archived?: boolean;
    user?: ClerkUser;
  }